import React from 'react';
import './Philosophy.css';

const Philosophy = () => {
  return (
    <section className="section philosophy-section">
      <h2 className="section-title">Philosophy</h2>
      
      <div className="philosophy-content">
        <p className="philosophy-text">
          We believe intelligence emerges not from scale alone, but from structure. 
          Decomposition, modularity, and specialization offer paths toward systems that are 
          not only more capable, but also more stable, interpretable, and aligned with our 
          ability to reason about them. The future of AI research lies in understanding 
          and designing these architectural primitives with precision and restraint.
        </p>
      </div>
    </section>
  );
};

export default Philosophy;